import { useState, useEffect } from 'react';
import { useI18n } from '../context/I18nContext';

export default function AccessibilitySettings() {
  const { t } = useI18n();
  const [largeText, setLargeText] = useState(() => localStorage.getItem('cogency_accessibility_large_text') === 'true');
  const [highContrast, setHighContrast] = useState(() => localStorage.getItem('cogency_accessibility_high_contrast') === 'true');
  const [reducedMotion, setReducedMotion] = useState(() => localStorage.getItem('cogency_accessibility_reduced_motion') === 'true');

  useEffect(() => {
    const root = document.documentElement;
    if (largeText) root.classList.add('accessibility-large-text');
    else root.classList.remove('accessibility-large-text');
    if (highContrast) root.classList.add('accessibility-high-contrast');
    else root.classList.remove('accessibility-high-contrast');
    if (reducedMotion) root.style.setProperty('--animation-duration', '0.01ms');
    else root.style.removeProperty('--animation-duration');
  }, [largeText, highContrast, reducedMotion]);

  const toggle = (key, setter, storageKey) => {
    const newVal = !key;
    setter(newVal);
    localStorage.setItem(storageKey, String(newVal));
  };

  return (
    <div className="accessibility-settings-panel">
      <h3>♿ {t('accessibility') || 'Accessibility'}</h3>
      <p className="section-desc">{t('accessibilityDesc') || 'Customize Cogency for your needs.'}</p>

      <div className="accessibility-option">
        <div className="accessibility-option-info">
          <span className="accessibility-option-label">🔤 {t('largeText') || 'Large Text'}</span>
          <span className="accessibility-option-desc">{t('largeTextDesc') || 'Increase text size by 15%'}</span>
        </div>
        <button
          className={`accessibility-toggle ${largeText ? 'active' : ''}`}
          onClick={() => toggle(largeText, setLargeText, 'cogency_accessibility_large_text')}
          aria-pressed={largeText}
        >
          {largeText ? '✓ On' : 'Off'}
        </button>
      </div>

      <div className="accessibility-option">
        <div className="accessibility-option-info">
          <span className="accessibility-option-label">🎨 {t('highContrast') || 'High Contrast'}</span>
          <span className="accessibility-option-desc">{t('highContrastDesc') || 'Strong colors for better visibility'}</span>
        </div>
        <button
          className={`accessibility-toggle ${highContrast ? 'active' : ''}`}
          onClick={() => toggle(highContrast, setHighContrast, 'cogency_accessibility_high_contrast')}
          aria-pressed={highContrast}
        >
          {highContrast ? '✓ On' : 'Off'}
        </button>
      </div>

      <div className="accessibility-option">
        <div className="accessibility-option-info">
          <span className="accessibility-option-label">🛑 {t('reducedMotion') || 'Reduced Motion'}</span>
          <span className="accessibility-option-desc">{t('reducedMotionDesc') || 'Minimize animations'}</span>
        </div>
        <button
          className={`accessibility-toggle ${reducedMotion ? 'active' : ''}`}
          onClick={() => toggle(reducedMotion, setReducedMotion, 'cogency_accessibility_reduced_motion')}
          aria-pressed={reducedMotion}
        >
          {reducedMotion ? '✓ On' : 'Off'}
        </button>
      </div>

      <div className="accessibility-help" style={{ marginTop: '20px', padding: '12px', background: 'var(--bg-hover)', borderRadius: '8px', fontSize: '13px' }}>
        <strong>⌨️ {t('keyboardShortcuts') || 'Keyboard Shortcuts'}</strong>
        <ul style={{ margin: '8px 0 0 16px', padding: 0, color: 'var(--text-secondary)' }}>
          <li>Ctrl + / — {t('focusInput') || 'Focus input field'}</li>
          <li>Ctrl + Enter — {t('sendMessage') || 'Send message'}</li>
          <li>Escape — {t('stopOrCancel') || 'Stop voice or cancel'}</li>
        </ul>
      </div>
    </div>
  );
}
